module.exports = __webpack_public_path__ + "static/media/3-4.d3bb6e9f.mp3";